



























































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
@Component({})
export default class InitiativeIndicatorMappingHeaderComponent extends Vue {
  Indicators: Array<any> = [];
  CallId: number;
  Data: Array<any> = [];
  search: string = "";
  indicatorTabs = [
    { text: "Select Indicator(s)", id: 0 },
  ];
  headers: any = [{ text: "Indicator", sortable: true, value: "Description" }];
  mounted() {
    if (
      this.$store.state["dashboard"] &&
      this.$store.state["dashboard"].componentId
    ) {
      let componentId = parseInt(this.$store.state["dashboard"].componentId);
      this.CallId = componentId;
      this.$services.application.GetIndicators(componentId).then((resp) => {
        if (resp) {
          this.Indicators = resp;
        }
      });
    }
    this.headers.map((x) => {
      x.text = this.$t(x.text);
    });
  }

  change(item) {
    let mappingData = {};
    mappingData["InitiativeCallId"] = this.CallId;
    mappingData["IndicatorId"] = item.IndicatorId;
    mappingData["Indicators"] = null;

    if (item.Selected) {
      this.$services.application
        .CreateIndicatorMapping(mappingData)
        .then((data) => {
          if (data) {
            // @ts-ignore
            this.$store.dispatch(
              "load",
              this.$store.state["intiativeCallIndicatorMappingIndex"]
            );
          }
        });
    } else {
      this.$services.application
        .DeleteIndicator(this.CallId, item.IndicatorId)
        .then((data) => {
          // @ts-ignore
          this.$store.dispatch(
            "load",
            this.$store.state["intiativeCallIndicatorMappingIndex"]
          );
        });
    }
  }

  Add() {}

  Save() {
  }

  Close() {
    this.$emit("Close", {});
  }
}
